import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Usernavbar.css";
import logo from "../assets/images/Picture2.png";
// Import notification icon (you can use an icon library or SVG)
// import { Bell, User, LogOut } from "lucide-react"; // Example using lucide-react

const SecondNavbar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true); // Assuming user is logged in
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [activeLink, setActiveLink] = useState("User");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [notificationCount, setNotificationCount] = useState(3); // Example notification count
  const [isClockedIn, setIsClockedIn] = useState(false);
const [seconds, setSeconds] = useState(0);

  const navigate = useNavigate();

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobileView(mobile);
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogout = () => {
    // Perform logout actions
    setIsLoggedIn(false);
    setShowProfileDropdown(false);
    setIsMobileMenuOpen(false);
    
    // Redirect to homepage
    navigate("/");
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    if (isMobileView) {
      setIsMobileMenuOpen(false);
    }
  };

  const handleProfileClick = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const handleNotificationClick = () => {
    // Handle notification click
    console.log("Notification clicked");
    // You can navigate to notifications page or show notifications dropdown
    // For now, just clear notifications as example
    setNotificationCount(0);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileDropdown && !event.target.closest('.second-navbar__profile-section')) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileDropdown]);


  useEffect(() => {
  let timer = null;

  if (isClockedIn) {
    timer = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);
  } else {
    clearInterval(timer);
  }

  return () => clearInterval(timer);
}, [isClockedIn]);
const formatTime = (secs) => {
  const h = String(Math.floor(secs / 3600)).padStart(2, "0");
  const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
  const s = String(secs % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};
const handleClockToggle = () => {
  if (isClockedIn) {
    setIsClockedIn(false); // Clock Out
  } else {
    setSeconds(0); // Reset when fresh clock-in
    setIsClockedIn(true); // Clock In
  }
};


  return (
    <div className="second-navbar">
      {/* Main Navbar */}
      <nav className="second-navbar__container">
        <div className="second-navbar__logo-container">
          <img src={logo} alt="Envision Logo" className="second-navbar__logo-img" />
          {/* Uncomment if you want text with logo */}
          {/* <div className="second-navbar__logo-text">Envision</div> */}
        </div>

        <div className="second-navbar__clock">
  <div className="clock-time">{formatTime(seconds)}</div>

  <button
    className={`clock-btn ${isClockedIn ? "out" : "in"}`}
    onClick={handleClockToggle}
  >
    {isClockedIn ? "Clock Out" : "Clock In"}
  </button>
</div>

        {/* Mobile Menu Toggle */}
        <button 
          className="second-navbar__mobile-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "✕" : "☰"}
        </button>

        <div className="second-navbar__right">
          {/* Navigation Links - Desktop */}
          <div className={`second-navbar__links ${isMobileMenuOpen ? 'second-navbar__links--open' : ''}`}>
            <a 
              href="/Adminhome" 
              className={`second-navbar__link ${activeLink === 'Admin' ? 'second-navbar__link--active' : ''}`}
              onClick={() => handleLinkClick('Admin')}
            >
              Admin
            </a>
            <a 
              href="/userhome" 
              className={`second-navbar__link ${activeLink === 'User' ? 'second-navbar__link--active' : ''}`}
              onClick={() => handleLinkClick('User')}
            >
              User
            </a>
            <a 
              href="/Managerdashbord" 
              className={`second-navbar__link ${activeLink === 'Manager' ? 'second-navbar__link--active' : ''}`}
              onClick={() => handleLinkClick('Manager')}
            >
              Manager
            </a>
          </div>

          {/* Notification and Profile Section */}
          <div className="second-navbar__profile-section">
            {/* Notification Icon */}
            <div 
              className="second-navbar__notification-icon"
              onClick={handleNotificationClick}
              title="Notifications"
            >
              {/* You can use an SVG or icon component here */}
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
              </svg>
              
              {/* Notification Badge */}
              {notificationCount > 0 && (
                <span className="second-navbar__notification-badge">
                  {notificationCount}
                </span>
              )}
            </div>

            {/* Profile Icon with Dropdown */}
            <div className="second-navbar__profile-icon" onClick={handleProfileClick}>
              U
            </div>

            {/* Profile Dropdown Menu */}
            {showProfileDropdown && (
              <div className="second-navbar__profile-dropdown">
                <div className="second-navbar__dropdown-item">
                  {/* You can use an icon component here */}
                  <svg 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                    className="second-navbar__dropdown-icon"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  Profile
                </div>
                <div 
                  className="second-navbar__dropdown-item" 
                  onClick={handleLogout}
                >
                  {/* You can use an icon component here */}
                  <svg 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                    className="second-navbar__dropdown-icon"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SecondNavbar;